__webpack_require__.p = "/assets/turbo/27fbcdbe/lascanach/_next/";